import { isElementInViewport } from '@theme/utilities';

class StickyAddToCart extends HTMLElement {
  constructor() {
    super();

    this.form = null;
    this.footer = null;
  }

  connectedCallback() {
    this.form = this.closest('[data-ref="product-form"]') || this.closest('bundle-builder');
    this.footer = document.querySelector('[data-ref="footer"]');

    this.#displayStickyAddToCart();

    window.addEventListener('scroll', () => {
      this.#displayStickyAddToCart();
    });
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', () => {
      this.#displayStickyAddToCart();
    });
  }

  #displayStickyAddToCart() {
    if (!this.form) {
      this.dataset.active = 'false';
      this.classList.remove('color-scheme-1');
      return;
    }

    // Sticky shows only after the form has scrolled fully above the viewport.
    // Above the form (rect.bottom > 0) or with the footer in view → hide.
    const rect = this.form.getBoundingClientRect();
    const isBelowForm = rect.bottom < 0;
    const footerVisible = this.footer ? isElementInViewport(this.footer) : false;

    if (isBelowForm && !footerVisible) {
      this.dataset.active = 'true';
      this.classList.add('color-scheme-1');
    } else {
      this.dataset.active = 'false';
      this.classList.remove('color-scheme-1');
    }
  }
}

if (!customElements.get('sticky-add-to-cart')) {
  customElements.define('sticky-add-to-cart', StickyAddToCart);
}
